<template lang="pug">
include ../plugins/pug/template
div
  div {{ $t(labelIdle) }}
  .file-uploader.cursor-pointer(@dragover.prevent @drop="handleDrop" @click="$refs.fileInput.click()")
    .file-uploader__btn {{ $t('chooseFIle') }}
    b {{ $t('or') }}
    span {{ $t('dragAndDrop') }}
  input(
    type="file"
    ref="fileInput"
    @change="handleFileSelect"
    style="display: none"
    :multiple="multiple"
    :accept="acceptedTypes")
  .file-preview
    v-card(v-for="(file, index) in files" :key="index").file-preview__item
      v-btn(color="error" @click="files.splice(index, 1)" fab x-small).item--remove
        v-icon mdi-close

      v-img.item--img(v-if="isIMG(file)" :src="getBlobFile(file)")

      .item--pdf(v-if="isPDF(file)")
        embed(
          :src="getBlobFile(file)")

      .item--file(v-if="!isIMG(file) && !isPDF(file)" )
        v-icon(size="75") mdi-file

      v-card-subtitle.pa-2 {{ file.name }}

  .file-errors

</template>

<script>
import newFileFromUrl from '@/mixins/newFileFromUrl'

export default {
  name: 'FileUploader',
  mixins: [newFileFromUrl],
  props: {
    value: { type: Array, default: null },
    count: { type: Number, default: 10 },
    labelIdle: { type: String, default: 'fileUploader' },
    maxFileSize: { type: Number, default: 1 },
    multiple: { type: Boolean, default: true },
    additionalAcceptedTypes: { type: String, default: '' },
    acceptedFileTypes: { type: String, default: '' },
    validateAcceptedTypes: { type: Boolean, default: false },
    existFiles: {
      type: Array,
      default: () => ([])
    },
  },
  data () {
    return {
      defaultAcceptedTypes: 'image/jpeg, image/png, application/pdf',
      files: [],
    }
  },
  computed: {
    acceptedTypes () {
      return `${this.acceptedFileTypes || this.defaultAcceptedTypes}, ${this.additionalAcceptedTypes}`
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (files) {
        if (files && files !== this.files) this.files = [...files]
      }
    },
    files: {
      handler () {
        this.$emit('changeFile')
        this.$emit('input', this.files)
      },
      deep: true
    },
    existFiles (val) {
      if (!val.length) return
      this.files = val
    }
  },
  mounted () {
    const dropzone = this.$el.querySelector('.file-uploader')
    dropzone.addEventListener('dragenter', () => dropzone.classList.add('active'))
    dropzone.addEventListener('dragleave', () => dropzone.classList.remove('active'))
    dropzone.addEventListener('dragover', event => event.preventDefault())
  },
  methods: {
    isIMG (file) {
      const imgFormats = ['image/jpeg', 'image/png', 'image/webp']
      return imgFormats.includes(file.type)
    },
    isPDF (file) {
      return 'application/pdf' === file.type
    },
    getFiles () {
      let statuses = []
      this.files.forEach(async file => {
        if (!(file instanceof Blob)) { statuses.push(1); return }
        let status = 1
        await this.getBase64(file).then(base => {
          let baseSplit = base.split(',')
          if (baseSplit[0].includes('application/pdf') && baseSplit[1][0] === 'A') {
            status = 8
          }
        })
        statuses.push(status)
      })
      return {
        files: this.files,
        statuses: statuses
      }
    },
    getBlobFile (file) {
      if (file.file !== undefined) return file.file
      const blobData = new Blob([file], { type: file.type })
      return URL.createObjectURL(blobData)
    },
    removeFile () {
      this.files = []
    },
    addFiles (files) {
      if (!this.multiple) this.files = []
      files.forEach(async file => {
        if (file.file) {
          const preparedFile = await this.createNewFileFromUrl(file.id, file.file)
          if (preparedFile) {
            if (this.multiple) this.files.push(preparedFile)
            else this.files = [preparedFile]
          }
        }
      })
    },
    addFile (file) {
      if (!file) return
      if (this.multiple) this.files.push(file)
      else this.files = [file]
    },
    handleDrop (event) {
      event.preventDefault()
      this.handleFiles(event.dataTransfer.files)
    },
    handleFileSelect () {
      this.handleFiles(this.$refs.fileInput.files)
    },
    isAcceptedFileType (file) {
      const extension = `.${file.name.split('.').pop().toLowerCase()}`
      const acceptedTypes = this.acceptedFileTypes
        ? this.acceptedFileTypes.split(',').map(type => type.trim().toLowerCase())
        : ['.pdf', '.png', '.jpg', '.jpeg']

      return acceptedTypes.includes(extension)
    },
    handleFiles (files) {
      const maxFileSize = this.maxFileSize * 1048576
      const validFiles = []

      for (let i = 0; i < files.length; i++) {

        const file = files[i]
        const isValidFileSize = file.size <= maxFileSize
        const isValidFileNameLength = file.name.length <= 100
        const isValidFileType = !this.validateAcceptedTypes || this.isAcceptedFileType(file)
        if (isValidFileSize && isValidFileNameLength && isValidFileType) {
          validFiles.push(file)
        } else {
          if (!isValidFileSize) this.$notification.error(this.$t('isFilesSizeInvalid', { size: this.maxFileSize }))
          if (!isValidFileNameLength) this.$notification.error(this.$t('isFileNameLengthInvalid'))
          if (!isValidFileType) this.$notification.error(this.$t('isFileTypeInvalid'))
        }
      }

      if (!this.multiple) {
        if (validFiles.length) this.files = [validFiles[validFiles.length - 1]]
      } else if (validFiles.length) {
        this.files.push(...validFiles)
      }
      // reset input value so selecting the same file again triggers change
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },
    getBase64 (file) {
      return new Promise(resolve => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          resolve(reader.result)
        }
      })
    }
  }
}
// тестовий коментар
</script>
